module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0096.png.bb75363f.jpg";